document.querySelectorAll('.pi-hero').forEach(function (hero) {
  var track = hero.querySelector('[data-hero-track]');
  var prevBtn = hero.querySelector('[data-hero-prev]');
  var nextBtn = hero.querySelector('[data-hero-next]');
  var dots = hero.querySelectorAll('[data-hero-dot]');
  var total = track ? track.children.length : 0;

  if (!track || total <= 1) return;

  var current = 0;
  var interval = parseInt(hero.dataset.autoplay, 10) || 6000;
  var timer = null;

  var isDragging = false;
  var startX = 0;
  var deltaX = 0;
  var trackWidth = 0;

  function goTo(index) {
    current = (index + total) % total;
    track.style.transform = 'translateX(-' + (current * 100) + '%)';
    dots.forEach(function (dot, i) {
      dot.classList.toggle('pi-hero__dot--active', i === current);
    });
  }

  function startAutoplay() {
    stopAutoplay();
    timer = setInterval(function () {
      goTo(current + 1);
    }, interval);
  }

  function stopAutoplay() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      goTo(current - 1);
      stopAutoplay();
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      goTo(current + 1);
      stopAutoplay();
    });
  }

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      goTo(parseInt(dot.dataset.index, 10));
      stopAutoplay();
    });
  });

  function dragStart(x) {
    isDragging = true;
    startX = x;
    deltaX = 0;
    trackWidth = track.getBoundingClientRect().width;
    track.style.transition = 'none';
    stopAutoplay();
  }

  function dragMove(x) {
    if (!isDragging) return;
    deltaX = x - startX;
    var basePercent = -(current * 100);
    var dragPercent = (deltaX / trackWidth) * 100;
    track.style.transform = 'translateX(' + (basePercent + dragPercent) + '%)';
  }

  function dragEnd() {
    if (!isDragging) return;
    isDragging = false;
    track.style.transition = 'transform 0.4s ease';

    var threshold = trackWidth * 0.15;
    if (deltaX > threshold) {
      goTo(current - 1);
    } else if (deltaX < -threshold) {
      goTo(current + 1);
    } else {
      goTo(current);
    }
  }

  track.addEventListener('pointerdown', function (e) {
    dragStart(e.clientX);
  });
  track.addEventListener('pointermove', function (e) {
    dragMove(e.clientX);
  });
  track.addEventListener('pointerup', dragEnd);
  track.addEventListener('pointerleave', function () {
    if (isDragging) dragEnd();
  });

  goTo(0);
  startAutoplay();
});